import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Navbar from './components/Navbar';
import SearchBarArea from './components/SearchBarArea';
import Footer from './components/Footer';
import HomePage from './components/pages/HomePage';
import BrowsePage from './components/pages/BrowsePage';
import WtbPage from './components/pages/WtbPage';
import RepairPage from './components/pages/RepairPage';
import AiAdvisorPage from './components/pages/AiAdvisorPage';
import ListingDetailPage from './components/pages/ListingDetailPage';
import LoginPage from './components/pages/LoginPage';
import SignupPage from './components/pages/SignupPage';
import CreateListingPage from './components/pages/CreateListingPage';
import ChatPage from './components/pages/ChatPage';
import UserProfilePage from './components/pages/UserProfilePage';
import PaymentGateway from './components/payment/PaymentGateway';

// Import mock data
import {
  mockUser
} from './mockData';

function App() {
  // State management
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Login and logout handlers
  const handleLogin = () => {
    setIsLoggedIn(true);
    setCurrentUser(mockUser);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setCurrentUser(null);
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Navbar 
          isLoggedIn={isLoggedIn} 
          currentUser={currentUser}
          onLogout={handleLogout}
        />
        <SearchBarArea />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/browse" element={<BrowsePage />} />
            <Route path="/wtb" element={<WtbPage />} />
            <Route path="/repair-shops" element={<RepairPage />} />
            <Route path="/ai-advisor" element={<AiAdvisorPage />} />
            <Route path="/listing/:id" element={<ListingDetailPage isLoggedIn={isLoggedIn} />} />
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="/signup" element={<SignupPage onLogin={handleLogin} />} />
            <Route path="/create-listing" element={<CreateListingPage />} />
            <Route path="/chat/:chatId" element={<ChatPage isLoggedIn={isLoggedIn} />} />
            <Route path="/profile/:userId" element={<UserProfilePage />} />
            <Route path="/payment" element={<PaymentGateway />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
